import '../scss/login.scss';
import Form from './modules/form.js';
import Modal from './modules/modal.js';

let formEl = document.querySelectorAll('[data-form]')[0];
if (formEl) {
  let form = new Form(formEl);
  form.floatLabels();
}

let modals = document.querySelectorAll('[data-modal]');
modals.forEach((el) => {
  let modal = new Modal(el);
  modal.init();
});



// WEBPACK FOOTER //
// ./assets/js/login.js